import { chain } from "lodash"

const sagas = chain(require.context(".", false, /^\.\/[^/]+\.[jt]sx?$/).keys())
  .map(id => require(`${id}`).saga)
  .filter(saga => !!saga)
  .value()

export default sagas
